// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"deac2bdf","455":"96c6d1d9","977":"51437ca5"}[chunkId] + ".chunk.js";
};